import React from "react";
import { AcceptOrReject } from "../actions/CompareDesignPolaris";
import { useTaskContext } from "../context";

export default function TableDataNeedReviewPrimaryAction({ node }) {
    const orderId = node?.orderId;
    const taskId = node?.id;

    const { refetch } = useTaskContext();

    return (
        <AcceptOrReject taskId={taskId} orderId={orderId} refetch={refetch} />
    );
}
